import type { ElementType } from 'react';

import { Typography } from '@mui/material';

import BreadcrumbContent from '../BreadcrumbContent';

export interface BreadcrumbCurrentProps {
  label: string;
  icon?: ElementType;
}

const BreadcrumbCurrent = ({ label, icon }: BreadcrumbCurrentProps) => (
  <Typography
    component="span"
    color="text.primary"
    sx={{ display: 'inline-flex', alignItems: 'center', fontWeight: 600 }}
  >
    <BreadcrumbContent label={label} icon={icon} />
  </Typography>
);

export default BreadcrumbCurrent;
